import {
  UseMutationResult,
  useMutation,
  useQueryClient,
} from '@tanstack/react-query'
import {
  useApiClient,
  getUseVisitLogKey,
  getUseVisitLogsKey,
  UsePutVisitLogStatusProps,
} from '@/hooks'
import { APIErrorResponse, VisitLog } from '@/types'
import { unwrapErrorResponse, unwrapResponse } from '@/utils'

export const usePutVisitLogApprove = ({
  id,
}: UsePutVisitLogStatusProps): UseMutationResult<
  VisitLog,
  APIErrorResponse,
  Pick<VisitLog, 'status_update_reason'>
> => {
  const client = useApiClient()

  const queryClient = useQueryClient()

  const visitLogsListKey = getUseVisitLogsKey()
  const visitLogItemKey = getUseVisitLogKey(id)

  return useMutation(
    (params) =>
      client
        .put(`plannings/visit_logs/${id}/approve/`, params)
        .then(unwrapResponse)
        .catch(unwrapErrorResponse),
    {
      onSuccess: () => {
        queryClient.invalidateQueries(visitLogsListKey)
        queryClient.invalidateQueries(visitLogItemKey)
      },
    }
  )
}
